import { db, functions } from "@/firebase";

// Spypoint cameras (cameras/{cameraId}) and their extract (functions/includes/cameraFunctions.js).
const camerasRef = db.collection("cameras");

export const CamerasService = {
  async getCamera(cameraId) {
    if (!cameraId) {
      return null;
    }
    const doc = await camerasRef.doc(cameraId).get();
    return doc.exists ? { ...doc.data(), id: doc.id } : null;
  },
  async listCameras() {
    const snapshot = await camerasRef.get();
    return snapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }))
      .sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "fr"));
  },
  // Admins only. Writes only these two fields: the whole section would overwrite the levels written meanwhile by
  // the gauge Cloud Function.
  async setSectionCamera(sectionId, { camera_info, camera_id }) {
    await db.collection("sections").doc(sectionId).update({ camera_info, camera_id });
  },
  // Admins only: last run, its error and the Spypoint account in use
  async getExtractStatus() {
    const doc = await db.collection("adminState").doc("cameraExtract").get();
    return doc.exists ? doc.data() : {};
  },
  async runExtract() {
    const result = await functions.httpsCallable("runCameraExtract")();
    return result.data;
  },
  async setCredentials(username, password) {
    const result = await functions.httpsCallable("setSpypointCredentials")({ username, password });
    return result.data;
  },
};
